module.exports = [
  'pz-masterpass',
  'pz-one-click-checkout',
  'pz-akifast',
  'pz-similar-products',
  'pz-masterpass-rest',
  'pz-gpay'
];
